<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
  <section class="relative my-8 w-full">
    <div class="mx-auto flex w-full max-w-screen-xl justify-center px-4">
      <SFHeadline class="mb-10 text-center text-gray-600" size="3xl">
        {{ $t('search_page.top_brands') }}
      </SFHeadline>
    </div>
    <div class="mx-auto max-w-full">
      <div
        class="flex flex-nowrap overflow-x-auto pr-4 scrollbar-hide xs:gap-4 lg:flex-wrap lg:gap-12 lg:overflow-x-visible"
        style="max-width: 100vw"
      >
        <div
          v-for="(brand, _idx) in brands"
          :key="`${brand.name}-${_idx}`"
          class="flex min-w-[180px] shrink-0 flex-col items-center"
        >
          <div
            class="mb-4 flex items-center justify-center overflow-hidden rounded-full bg-gray-300 xs:size-[160px] lg:size-[223px]"
          >
            <img
              :src="brand.image"
              :alt="brand.name"
              class="size-28 object-contain brightness-0 invert md:size-20"
            />
          </div>
          <div class="mt-1 text-lg font-bold text-gray-700">
            {{ brand.name }}
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { SFHeadline } from '#storefront-ui/components'

// TODO: Integrate with API
const brands = [
  { name: 'NIKE', image: 'https://via.placeholder.com/180x180?text=NIKE' },
  { name: 'adidas', image: 'https://via.placeholder.com/180x180?text=adidas' },
  {
    name: 'Karl Kani',
    image: 'https://via.placeholder.com/180x180?text=Karl+Kani',
  },
  {
    name: 'Pegador',
    image: 'https://via.placeholder.com/180x180?text=Pegador',
  },
  { name: 'Jordan', image: 'https://via.placeholder.com/180x180?text=Jordan' },
]
</script>

<style scoped>
/* Hide scrollbar for Chrome, Safari and Opera */
.scrollbar-hide::-webkit-scrollbar {
  display: none;
}
/* Hide scrollbar for IE, Edge and Firefox */
.scrollbar-hide {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
</style>
